// src/utils/currenciesHelper.js

/**
 * Comprehensive list of world currencies with codes and labels
 * Data is comprehensive and production-ready
 */
export const getAllCurrencies = () => {
  const currencies = [
        { code: "USD", label: "US Dollar", symbol: "$" },
    { code: "NZD", label: "New Zealand Dollar", symbol: "NZ$" },
    { code: "AUD", label: "Australian Dollar", symbol: "A$" },
    { code: "GBP", label: "British Pound", symbol: "£" },
    { code: "HKD", label: "Hong Kong Dollar", symbol: "HK$" },
    { code: "SGD", label: "Singapore Dollar", symbol: "S$" },
    { code: "EUR", label: "Euro", symbol: "€" },
    { code: "CAD", label: "Canadian Dollar", symbol: "C$" },
    { code: "INR", label: "Indian Rupee", symbol: "₹" },
  ];

  // Sort by code for consistency
  return currencies.sort((a, b) => a.code.localeCompare(b.code));
};

/**
 * Search currencies by code or label
 * @param {string} query - Search term
 * @returns {object[]} Matching currencies
 */
export const searchCurrencies = (query) => {
  if (!query || query.trim() === '') return getAllCurrencies();
  
  const lowerQuery = query.toLowerCase().trim();
  return getAllCurrencies().filter(currency =>
    currency.code.toLowerCase().includes(lowerQuery) ||
    currency.label.toLowerCase().includes(lowerQuery)
  );
};

/**
 * Get currency by code
 * @param {string} code - Currency code (e.g., "USD")
 * @returns {object|null} Currency object or null
 */
export const getCurrencyByCode = (code) => {
  return getAllCurrencies().find(c => c.code === code.toUpperCase()) || null;
};

/**
 * Format currency for display
 * @param {string} code - Currency code
 * @returns {string} Formatted display (e.g., "USD - US Dollar")
 */
export const formatCurrency = (code) => {
  const currency = getCurrencyByCode(code);
  if (!currency) return code;
  return `${currency.code} - ${currency.label}`;
};

/**
 * Validate if currency code exists
 * @param {string} code - Currency code
 * @returns {boolean}
 */
export const isValidCurrency = (code) => {
  return getAllCurrencies().some(c => c.code === code.toUpperCase());
};
